import apiHandler from "middlewares/apiHandler";
import { LocationConfiguration } from "pages/Settings/Configuration/data/LocationConfiguration";

/**
 * Uploads a location image to the server.
 *
 * @param model - The location configuration model containing the image data to be uploaded.
 * @returns A promise that resolves to the updated `LocationConfiguration` object after the image is successfully uploaded.
 */
export const _uploadLocationImage = async (formData: FormData) => {
  return apiHandler.post<any>("location/uploadimage", formData,'form');
};

/**
 * Fetches the location image based on the provided location ID.
 *
 * @param locationId - The ID of the location whose image is to be retrieved. 
 *                It can be a number or undefined.
 * @returns A promise that resolves to the location's configuration containing the image.
 */
export const _getLocationImage = async (locationId: number | undefined) => {
  return apiHandler.get<LocationConfiguration>(`location/image/${locationId}`);
};
